module.exports = __webpack_public_path__ + "img/percent.14d8c3ca.svg";